import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

const Form = (props) => {
    if (props.actionType === 'list') {
        return null;
    }

    if (props.fetchingElement) {
        return (
            <div className="form-container">
                <div className="loading-container">
                    <i className="fas fa-circle-notch fa-spin" /> Loading data...
                </div>
            </div>
        );
    }

    const handleSetField = (field, event) => {
        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        props.setField(field, value);
    };

    const handleCellChange = (row, col, event) => {
        props.setTableCell(row, col, event.target.value);
    };

    const handleAddTableRow = () => {
        if (props.table.length === 0) {
            props.setTable([['']]);
            return;
        }

        let columns = [];
        for (let i = 0; i < props.totalColumns; i++) {
            columns.push('');
        }

        let table = [...props.table];
        table.push(columns);
        props.setTable(table);
    };

    const handleAddTableColumn = () => {
        if (props.table.length === 0) {
            props.setTable([['']]);
            return;
        }

        let table = [...props.table];
        for (let i = 0; i < table.length; i++) {
            table[i].push('');
        }

        props.setTable(table);
    };

    const handleRemoveRow = (index) => {
        if (parseInt(props.totalRows) === 1) {
            props.setTable([]);
            return;
        }

        let table = [...props.table];
        table.splice(index, 1);
        props.setTable(table);
    };

    const handleRemoveColumn = (index) => {
        if (parseInt(props.totalColumns) === 1) {
            props.setTable([]);
            return;
        }

        let table = [...props.table];

        for (let i = 0; i < props.totalRows; i++) {
            table[i].splice(index, 1);
        }
        
        props.setTable(table);
    };

    const renderTable = () => {
        if (props.table.length === 0) {
            return <div className="no-data">No data</div>;
        }

        let deleteColumns = [];
        for (let i = 0; i < props.totalColumns; i++) {
            deleteColumns.push(
                <td className="delete-column">
                    <div className="delete-container">
                        <div className="link" onClick={handleRemoveColumn.bind(this, i)}>Remove Column</div>
                    </div>
                </td>
            );
        }

        return (
            <table>
                <tr>{deleteColumns}</tr>
                {props.table.map((row, rowIndex) => {
                    return (
                        <tr>
                            {row.map((column, columnIndex) => {
                                let deleteRow = null
                                if (columnIndex === props.totalColumns - 1) {
                                    deleteRow = (
                                        <td className="delete-row">
                                            <div className="delete-container">
                                                <div className="link" onClick={handleRemoveRow.bind(this, rowIndex)}>Remove Row</div>
                                            </div>
                                        </td>
                                    );
                                }
                                return (
                                    <Fragment>
                                        <td>
                                            <input type="text" value={column} onChange={handleCellChange.bind(this, rowIndex, columnIndex)} />
                                        </td>
                                        {deleteRow}
                                    </Fragment>
                                );
                            })}
                        </tr>
                    );
                })}
            </table>
        );
    };

    return (
        <div className="form-container">
            <div className="fields">
                <div className="field">
                    <div className="label">Name <span className="required">*</span>:</div>
                    <input type="text" value={props.item.name} onChange={handleSetField.bind(this, 'name')} placeholder="Name" />
                </div>
                <div className="field">
                    <div className="label">Active <span className="required">*</span>:</div>
                    <select value={props.item.active} onChange={handleSetField.bind(this, 'active')}>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>
            </div>
            <h2>
                <div>Chart</div>
                <button className="admin-button add-row-button" onClick={handleAddTableRow}>Add Row</button>
                <button className="admin-button add-column-button" onClick={handleAddTableColumn}>Add Column</button>
            </h2>
            <div className="chart-container">
                {renderTable()}
            </div>
            <div className="lines-container">
                <div className="field">
                    Description Line 1:
                    <input type="text" value={props.item.line1} onChange={handleSetField.bind(this, 'line1')} />
                </div>
                <div className="field">
                    Description Line 2:
                    <input type="text" value={props.item.line2} onChange={handleSetField.bind(this, 'line2')} />
                </div>
                <div className="field">
                    Description Line 3:
                    <input type="text" value={props.item.line3} onChange={handleSetField.bind(this, 'line3')} />
                </div>
                <div className="field">
                    Description Line 4:
                    <input type="text" value={props.item.line4} onChange={handleSetField.bind(this, 'line4')} />
                </div>
                <div className="field">
                    Description Line 5:
                    <input type="text" value={props.item.line5} onChange={handleSetField.bind(this, 'line5')} />
                </div>
                <div className="field">
                    Description Line 6:
                    <input type="text" value={props.item.line6} onChange={handleSetField.bind(this, 'line6')} />
                </div>
            </div>
            <div className="buttons-container">
                <div className="button-container">
                    <Link to="/admin/size-charts">
                        <button className="cancel-button">Cancel</button>
                    </Link>
                </div>
                <div className="button-container">
                    <button className="save-button" onClick={props.saveElement} disabled={props.saving}>
                        {props.saving ? <i className="fas fa-circle-notch fa-spin" /> : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Form;
